<script>
  import { X } from 'lucide-svelte';
  import { normalizeUrl, preferInlineMediaUrl, isPDF, isImage, isVideo } from '$lib/utils';
  import ImageGalleryViewer from '@components/ImageGalleryViewer.svelte';
  import MediaVideoPlayer from '@components/messenger/MediaVideoPlayer.svelte';
  import PdfModalViewer from '@components/tools/PdfModalViewer.svelte';

  export let item = null;
  export let onClose = () => {};
</script>

{#if item}
  {#if isImage(item.url, item.mime || '')}
    <ImageGalleryViewer images={[preferInlineMediaUrl(item.url, item.mime || '')]} index={0} onClose={onClose} />
  {:else if isVideo(item.url, item.mime || '')}
    <div class="fixed inset-0 z-50 flex items-center justify-center bg-black/80 px-3">
      <button
        type="button"
        onclick={onClose}
        class="fixed right-4 top-4 z-50 flex h-9 w-9 items-center justify-center rounded-full bg-black/40 text-white backdrop-blur transition hover:bg-black/60"
        aria-label="Đóng preview">
        <X size={18} />
      </button>
      <MediaVideoPlayer src={preferInlineMediaUrl(item.url, item.mime || '')} name={item.name || 'video'} mode="modal" mime={item.mime || ''} />
    </div>
  {:else if isPDF(item.url, item.mime || '')}
    <PdfModalViewer url={preferInlineMediaUrl(item.url, item.mime || '')} onClose={onClose} />
  {:else}
    <div class="fixed inset-0 z-50 grid place-items-center bg-black/80 px-6">
      <a href={normalizeUrl(item.url)} target="_blank" rel="noreferrer" class="rounded-lg bg-white px-4 py-2 text-sm font-medium text-slate-900">
        Mở file
      </a>
    </div>
  {/if}
{/if}
